const appConfig = {
  apiPrefix: "/api",
  authenticatedEntryPath: "/home/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  enableMock: true,
};

export default appConfig;
